import React from 'react';

interface FooterProps {
  companyName: string;
  year: number;
}

export const Footer: React.FC<FooterProps> = ({ companyName, year }) => {
  const darkNavy = '#2c3e50';
  const emeraldGreen = '#58a08c';

  const linkStyle: React.CSSProperties = {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '0.8rem',
    opacity: 0.8
  };

  return (
    
    <footer
      id="contact"
      style={{
        background: darkNavy,
        color: '#fff',
        padding: '6px 8%',
        fontFamily: 'inherit',

        scrollMarginTop: '90px' // 👈 IMPORTANT
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          alignItems: 'center',
          gap: '16px'
        }}
      >
        {/* Logo */}
        <a href={`${process.env.PUBLIC_URL}/`} aria-label="ViZmerald home">
          <img
            src={`${process.env.PUBLIC_URL}/images/ViZmeraldLogo.png`}
            alt="ViZmerald"
            style={{
              height: '100px',
              opacity: 0.95
            }}
          />
        </a>

        {/* Infos + contact + réseaux */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '12px'
          }}
        >
          {/* Adresse + contact */}
          <div style={{ fontSize: '0.75rem', opacity: 0.8, lineHeight: 1.4 }}>
            <strong style={{ color: emeraldGreen }}>Adresse & Contacts: </strong><br />
            Novation-City, Sousse · Tunisie<br />
            <a href="mailto:contact@vizmerald.com" style={linkStyle}>
              contact@vizmerald.com
            </a>
            <br />
            <a href="tel:+21624444208" style={linkStyle}>+216 24 444 208</a> 
          </div>

          {/* Réseaux sociaux (icônes) */}
          <div style={{ display: 'flex', gap: '12px' }}>
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/vizmerald/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              style={{ opacity: 0.8 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#ffffff">
                <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.2 2.3-2.47 4.73-2.47 5.05 0 5.98 3.32 5.98 7.64V24h-5V15.4c0-2.05-.04-4.7-2.87-4.7-2.87 0-3.31 2.24-3.31 4.55V24h-5V8z"/>
              </svg>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/ViZmerald"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              style={{ opacity: 0.8 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#ffffff">
                <path d="M22.68 0H1.32C.59 0 0 .59 0 1.32v21.36C0 23.41.59 24 1.32 24h11.49v-9.29H9.69v-3.62h3.12V8.41c0-3.1 1.89-4.79 4.65-4.79 1.32 0 2.45.1 2.78.14v3.22h-1.91c-1.5 0-1.79.71-1.79 1.76v2.31h3.58l-.47 3.62h-3.11V24h6.1c.73 0 1.32-.59 1.32-1.32V1.32C24 .59 23.41 0 22.68 0z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Copyright ultra compact */}
      <div
        style={{
          textAlign: 'center',
          marginTop: '4px',
          fontSize: '0.65rem',
          opacity: 0.55
        }}
      >
        © {year} {companyName}
      </div>
    </footer>
  );
};
